import RejectBlock from 'components/common/reject-block'

export default function UserOnly({ children }) {
  const { user, loading } = useCurrent()
  const t = useI18n()
  const { open } = usePanel()
  const openAuth = () => open('auth')
  if (loading) return ''
  if (user) return children
  return (
    <RejectBlock title={ t('common:authenticate.userOnly.notYetLogin') }>
      <div className='mb-32'>
        { t('common:authenticate.userOnly.textBeforeLoginButton')}
        <span className='text-business px-1 cursor-pointer' onClick={ openAuth }>{ t('common:login') }</span>
        { t('common:authenticate.userOnly.textAfterLoginButton') }
      </div>
    </RejectBlock>
  )
}
